// auth modules
import axios from '@/api/http_client';
import {getToken} from '@/common'
import Router from '../../router'
import {
  CHECK_TAKEN,
  LOGIN_URL,
  RESET_EMAIL_URL,
  SEND_VERIFICATION_CODE,
  SIGNUP_URL,
  RESET_PASSWORD,
  CUSTOMER_INFORMATION_URL,
  CHANGE_PASSWORD,
  AUTH2_TOKEN_URL_GOOGLE,
  AUTH2_TOKEN_URL_WECHAT,
  AUTH2_TOKEN_URL_APP_WECHAT,
  AUTH2_TOKEN_URL_APP_APPLE,
  AUTH2_TOKEN_URL_FACEBOOK,
  GUEST_SIGNUP,
  DELETE_ACCOUNT_URL,
  PHONE_ACTIVE_CODE
} from '../../api/url'
import {getCid} from "../../common";
import i18n from '@/i18n'

const handleLoginSuccess = function () {
  const {name: currentName, path: currentPath} = Router.history.current
  if (['/home', '/cart', '/mobileCart'].includes(currentPath)) {
    return Router.go()
  }
  if (currentName === 'Referral') {
    Router.push('/');
    Router.go();
    return
  }
  Router.push('/home');
}

// initial state
const state = {
  loginErrorMessage: '',
  resetEmailMessage: '',
  token: getToken() || '',
  loggedIn: false,
  userDetails: {},
  registerErrorMessage: '',
  bindingErrorStatus: false,

  loginErrorMessageBind: '',
  bindErrorMessageTop: '',
}

function getHeaderWithToken() {
  const token = getToken();
  const headers = {
    Authorization: `JWT ${token}`,
  }
  return headers
}
// actions
const actions = {
  LoginRequest: ({ commit, dispatch }, data) => {
    commit('updateErrorMessage', null)
    const cid = getCid()
    cid && (data.Cid = cid)
    axios({url: LOGIN_URL, data, method: 'POST'})
    .then(res => {
      localStorage.setItem('token', res.data.token);
      commit('updateToken', res.data.token);
      commit('updateLoginStatus', true);
      dispatch(`fetchCustomerInformation`, res.data.token);
      handleLoginSuccess()
    })
    .catch(err => {
      commit('updateErrorMessage', err);
    })
  },
  LoginBindRequest: ({ commit, dispatch }, data) => {
    commit('updateErrorMessageBind', null);
    const cid = getCid()
    cid && (data.Cid = cid)
    axios({url: LOGIN_URL, data, method: 'POST'})
    .then(res => {
      commit('updateToken', res.data.token);
      commit('updateLoginStatus', true);
      dispatch(`fetchCustomerInformation`, res.data.token);
      localStorage.setItem('token', res.data.token);
      dispatch(`Auth2RequestBind`, data);
    })
    .catch(err => {
      console.log("err", err);
      commit('updateErrorMessageBind', err);
    })
  },
  Auth2RequestBind: ({ commit, dispatch }, data) => {
    commit('updateBindErrorTop', null);
    const token = getToken();
    let typeURL = '';
    const {type, code, unionid, user} = data
    if (type==='Google') {
      typeURL = AUTH2_TOKEN_URL_GOOGLE;
    }
    if (type==='Wechat') {
      if (unionid) {// app微信登录
        typeURL = AUTH2_TOKEN_URL_APP_WECHAT;
      } else {
        typeURL = AUTH2_TOKEN_URL_WECHAT;
      }
    }
    if (type==='Facebook') {
      typeURL = AUTH2_TOKEN_URL_FACEBOOK;
    }
    if (type==='Apple') {
      typeURL = AUTH2_TOKEN_URL_APP_APPLE;
    }
    const params = {}
    const cid = getCid()
    cid && (params.Cid = cid)
    const config = {
      method: 'POST',
      url: typeURL + '?code=' + code,
      headers: {
        Authorization: `JWT ${token}`,
      },
      params
    };
    if (unionid) {// app微信登录
      config.url = typeURL + '?unionid=' + unionid
    } else if (user) {// apple登录
      config.url = typeURL + '?user=' + user
    }
    axios(config)
    .then(res => {
      handleLoginSuccess()
      // success binding message?
    })
    .catch(err => {
      commit('updateBindErrorTop', 'Logged in but unable to bind your account. Please try again.');
    })
  },
  Auth2RequestToken: ({ commit, dispatch }, data) => {
    commit('updateBindingError', false);
    let typeURL = '';
    const {type, token, unionid, user} = data
    if (type==='Google') {
      typeURL = AUTH2_TOKEN_URL_GOOGLE;
    }
    if (type==='Wechat') {
      if (unionid) {// app微信登录
        typeURL = AUTH2_TOKEN_URL_APP_WECHAT;
      } else {
        typeURL = AUTH2_TOKEN_URL_WECHAT;
      }
    }
    if (type==='Facebook') {
      typeURL = AUTH2_TOKEN_URL_FACEBOOK;
    }
    if (type==='Apple') {
      typeURL = AUTH2_TOKEN_URL_APP_APPLE;
    }
    let url = typeURL + '?code=' + token;
    if (unionid) {// app微信登录
      url = typeURL + '?unionid=' + unionid;
    } else if (user) {// apple登录
      url = typeURL + '?user=' + user;
    }
    const params = {}
    const cid = getCid()
    cid && (params.Cid = cid)
    axios({url: url, method: 'GET', params: params})
    .then(res => {
      commit('updateToken', res.data.token);
      commit('updateLoginStatus', true);
      dispatch(`fetchCustomerInformation`, res.data.token);
      localStorage.setItem('token', res.data.token);
      handleLoginSuccess()
    })
    .catch(err => {
      if (err.response.status === 400) {
        console.log("err request auth2", err.response);
        if (unionid) {
          Router.push('/bindaccount?unionid=' + unionid + '&type=' + type);
        } else if (user) {
          Router.push('/bindaccount?user=' + user + '&type=' + type);
        } else {
          Router.push('/bindaccount?code=' + err.response.data + '&type=' + type);
        }
      } else {
        console.log("updateBindingError", err.response.statusText);
        commit('updateBindingError', true);
      }
      // Router.push('/bindaccount?code=' + data.token + '&type=' + data.type);
    })
  },
  registerRequest: (context, data) => axios({ url: SIGNUP_URL, data, method: 'POST' }),
  checkUsername: ({ commit, dispatch }, data) => {
    commit('updateRegisterErrorMessage', '')
    // 返回true证明已存在
    return axios({url: CHECK_TAKEN, data, method: 'POST'})
    .then(res => {
      if (res.data.isTaken) {
        commit('updateRegisterErrorMessage', 'username');
      }
      return res.data.isTaken
    })
    .catch(err => {
      commit('updateRegisterErrorMessage', 'fail');
      return true
    })
  },
  checkUsernameReturn: (context, data) => axios({ url: CHECK_TAKEN, data, method: 'POST' }),
  checkEmail: ({ commit, dispatch }, data) => {
    commit('updateRegisterErrorMessage', '')
    // 返回true证明已存在
    return axios({url: CHECK_TAKEN, data, method: 'POST'})
    .then(res => {
      if (res.data.isTaken) {
        commit('updateRegisterErrorMessage', 'email');
      }
      return res.data.isTaken
    })
    .catch(err => {
      commit('updateRegisterErrorMessage', 'fail');
      return true
    })
  },
  resetEmail: (context, data) => axios({ url: `${RESET_EMAIL_URL}${data}/`, method: 'POST' }),
  sentVerificationCode: (context, data) =>  axios({ url: `${SEND_VERIFICATION_CODE}${data.code}/`,data: {token: data.token}, method: 'POST' }),
  resetPassword: (context, data) => axios({ url: `${RESET_PASSWORD}`, data, method: 'POST' }),
  changePassword: (context, data) => axios({url: `${CHANGE_PASSWORD}`, data, method: 'POST', headers: getHeaderWithToken()}),
  fetchCustomerInformation(context, tokken){
    const token = getToken() || tokken
    const config = {
      method: 'get',
      url: CUSTOMER_INFORMATION_URL,
      headers: {
        Authorization: `JWT ${token}`,
      }
    };
    axios(config)
    .then((response) => {
      context.commit('fetchCustomerInformation', response.data);
    }, (err) => {
      console.log("fetchCustomerInformation error:", err);
    })
  },
  guestCheckout(context, data) {
    const config = {
      method: 'POST',
      url: GUEST_SIGNUP,
      data: data,
    };
  return axios(config)
  },
  deleteAccount({ commit }) {
    axios({url: `${DELETE_ACCOUNT_URL}`, method: 'POST', headers: getHeaderWithToken()})
      .then(res => {
        commit('logout')
      })
      .catch(err => {
        console.log(err);
      })
  },
  getPhoneActiveCode(context, phone) {
    return axios({url: `${PHONE_ACTIVE_CODE}${phone}/`, method: 'POST'})
      .then(res => {
        const resData = res.data
        return {
          type: 0,
          data: resData
        }
      })
      .catch(err => {
        const errData = err.response.data
        if (typeof errData === 'string') {
          const lowerErr = errData.toLowerCase()
          // 电话已注册
          if (lowerErr.includes('phone') && lowerErr.includes('exists')) {
            return {
              type: 1,
              data: errData
            }
          }
          // 再试一次，可能是没有发送成功
          if (lowerErr.includes('try') && lowerErr.includes('again')) {
            return {
              type: 2,
              data: errData
            }
          }
        }
        // 意料之外，先默认没有发送成功
        return {
          type: 2,
          data: errData
        }
      })
  }
};

// mutations
const mutations = {
  updateToken: (state, token) => {
    state.token = token
  },
  updateErrorMessage: (state, message) => {
    if(message) {
      state.loginErrorMessage = i18n.t('unable_to_login_with_provided_credentials');
    }else {
      state.loginErrorMessage = "";
    }
  },
  updateErrorMessageBind: (state, message) => {
    if(message) {
      state.loginErrorMessageBind = i18n.t('unable_to_login_with_provided_credentials');
    }else {
      state.loginErrorMessageBind = "";
    }
  },
  updateBindErrorTop: (state, message) => {
    if(message) {
      state.bindErrorMessageTop = message;
    }else {
      state.bindErrorMessageTop = "";
    }
  },
  updateBindingError: (state, status) => {
      state.bindingErrorStatus = status;
  },
  updateRegisterErrorMessage: (state, message) => {
      state.registerErrorMessage = message;
  },
  updateLoginStatus: (state, status) => {
    state.loggedIn = status;
  },
  logout: (state) => {
    state.loggedIn = false;
    state.token = '';
    const appSystemInfo = localStorage.getItem('appSystemInfo')
    const lang = localStorage.getItem('Lang') || 'en'
    localStorage.clear();
    appSystemInfo && localStorage.setItem('appSystemInfo', appSystemInfo)
    localStorage.setItem('Lang', lang)
    Router.push('/');
    Router.go();
  },
  fetchCustomerInformation(state,payload){
    state.userDetails = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/auth.js